export default __webpack_public_path__ + "fc19adbb0b1df1c54703f633220f3bbe.svg";